export const getList = (state) => state.list
export const getListTags = (state) => state.listTags
export const getPriority = (state) => state.priority
export const getModalProposalPriority = (state) => state.modalProposalPriority
export const getModalTemplatePriority = (state) => state.modalTemplatePriority
